/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ErrorToastIcon, InfoToastIcon, SuccessToastIcon, WarningToastIcon } from '@icons';
import { PropsWithChildren, ReactNode } from 'react';
import { NavigateFunction } from 'react-router-dom';

type NotificationToastProps = PropsWithChildren & {
  title?: ReactNode;
  text?: ReactNode;
  variant: 'success' | 'error' | 'warning' | 'info';
  txcCode?: string;
  link?: string;
  onNavigate: NavigateFunction;
};

const toastTypes = {
  success: {
    container: `text-base-5 bg-white`,
  },
  error: {
    container: `text-danger-40 bg-white`,
  },
  warning: {
    container: `text-warning-5 bg-white`,
  },
  info: {
    container: `text-black bg-white`,
  },
};

const toastTypesIcon = {
  success: <SuccessToastIcon />,
  error: <ErrorToastIcon />,
  warning: <WarningToastIcon />,
  info: <InfoToastIcon />,
};

const defaultType = {
  container: `text-base-10 bg-base-50`,
};

const NotificationToast = ({ title, text, children, variant, txcCode, link, onNavigate }: NotificationToastProps) => {
  const handleClick = () => {
    if (link) {
      onNavigate(link);
    }
  };
  const { container: containerClassname } = toastTypes[variant] || defaultType;
  return (
    <div
      className={`w-[342px] h-fit py-3 pl-3 pr-3 gap-4 items-center border-1 border-base-40 border-opacity-70 rounded-[10px] flex ${containerClassname}`}
    >
      <div className="flex justify-center">{toastTypesIcon[variant]}</div>
      <div onClick={handleClick} className="flex flex-col text-sm gap-1">
        <div className="flex flex-row gap-1">
          {txcCode && (
            <span className={`text-base-5 font-medium text-s-sb cursor-pointer ${containerClassname}`}>
              {txcCode}:{' '}
            </span>
          )}
          {title && <span className={`font-medium text-s-sb cursor-pointer ${containerClassname}`}>{title}</span>}
        </div>
        {text && <span className="text-base-10 text-m-r">{text}</span>}
        {children && <span>{children}</span>}
      </div>
    </div>
  );
};

export default NotificationToast;
